import { useState, useEffect } from 'react';
import { Container, Row, Col, InputGroup } from 'react-bootstrap';
import { axiosInstance } from 'src/api/axios';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import AddButton from 'src/Admin/components/User/UserFormNew/components/AddButton';
import FilterModal from 'src/Admin/components/common/filter-modal/FilterModal';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import TextInput from 'src/Components/GenericInputText/TextInput';
import SearchIndicationPage from '../SearchIndicationPage';
import APIEndpoints from '../../../../../../api/APIEndpoints';
import Lists from '../Lists';
import Skeleton from 'src/Admin/components/common/skeleton';

const DoctorPanel = ({
  label,
  onSelectedDoctorsHandler,
  editAffiliatedRecords,
  selectedItemsData,
  selectedAllDoctorsOfSameNPI,
  setSelectedAllDoctorsOfSameNPI,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [doctorsList, setDoctorsList] = useState([]);
  const [selectedDoctorsList, setSelectedDoctorsList] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(false);
  const [doctorsDataListObject, setDoctorsDataListObject] = useState({});
  const [unCheckedItems, setUnCheckedItems] = useState([]);

  const onSearchHandler = (e) => {
    setSearchString(e.target.value);
    if (e.target.value?.length >= 3) {
      console.log('call api for searching doctors');
      setCurrentPage(1);
      //search doctors
      searchDoctors(e.target.value, 1);
    } else {
      setDoctorsList([]);
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    if (currentPage > 1) {
      searchDoctors(searchString);
    }
  }, [currentPage]);

  useEffect(() => {
    setDoctorsList([...selectedItemsData.map((d) => d.ConnectorID)]);
    setSelectedDoctorsList([
      ...doctorsList,
      ...selectedItemsData.map((d) => d.ConnectorID),
    ]);

    setDoctorsDataListObject(
      Object.assign(
        {},
        ...selectedItemsData.map((doc) => {
          return { [doc.ConnectorID]: doc };
        }),
      ),
    );
  }, [selectedItemsData, isModalOpen]);

  //search doctors api call
  const searchDoctors = async (searchTerm, page) => {
    setIsLoadingPage(true);
    try {
      const pageToLoad = page || currentPage;
      const SearchDoctorsListResponse = await axiosInstance.get(
        APIEndpoints.getDoctorsListResources() +
          'pagenumber/' +
          pageToLoad +
          '/pagesize/10/searchKey/' +
          searchTerm,
      );

      const doctorsListData = SearchDoctorsListResponse.data;

      if (
        SearchDoctorsListResponse.status ===
        HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        const { TotalRecords } = doctorsListData.Response.Pagination;

        const updatedDoctors = [
          ...doctorsList,
          ...doctorsListData.Response.PhysicianViewDetails.map(
            (d) => d.ConnectorID,
          ),
        ];

        if (currentPage > 1) {
          setDoctorsList([
            ...doctorsList,
            ...doctorsListData.Response.PhysicianViewDetails.map(
              (d) => d.ConnectorID,
            ),
          ]);
        } else {
          setDoctorsList([
            ...doctorsListData.Response.PhysicianViewDetails.map(
              (d) => d.ConnectorID,
            ),
          ]);
        }

        setDoctorsDataListObject({
          ...doctorsDataListObject,
          ...Object.assign(
            {},
            ...doctorsListData.Response.PhysicianViewDetails.map((doc) => {
              return { [doc.ConnectorID]: doc };
            }),
          ),
        });

        if (TotalRecords > updatedDoctors.length) {
          setHasMoreData(true);
        } else {
          setHasMoreData(false);
        }

        setIsLoadingPage(false);
      }
    } catch (error) {
      setIsLoadingPage(false);
      setDoctorsList([]);
      setDoctorsDataListObject({});
    }
  };

  const handleAddDoctors = () => {
    setIsModalOpen(true);
  };

  const applyFilterHandler = () => {
    if (setSelectedDoctorsList.length > 0) {
      onSelectedDoctorsHandler(
        [...new Set(selectedDoctorsList)].map(
          (docConnectorId) => doctorsDataListObject[docConnectorId],
        ),
      );
    } else {
      onSelectedDoctorsHandler([]);
    }

    const tempObj = selectedAllDoctorsOfSameNPI;
    unCheckedItems.map((ele) => {
      const index = tempObj.indexOf(ele.NationalProviderId);

      if (index > -1) {
        tempObj.splice(index, 1);
      }
      return;
    });

    setSelectedAllDoctorsOfSameNPI(tempObj);

    setIsModalOpen(false);
    setSearchString('');
    setDoctorsList([]);
    setSelectedDoctorsList([]);
    setHasMoreData(false);
    setDoctorsDataListObject({});
    setUnCheckedItems([]);
  };

  const selectChangeHandler = (e, doctorData) => {
    const { name, checked } = e.target;
    if (name === 'select-all-doctors') {
      if (checked) {
        setSelectedDoctorsList([...doctorsList]);
      } else {
        setSelectedDoctorsList([]);
      }
    } else {
      if (checked) {
        if (!selectedDoctorsList.includes(doctorData.ConnectorID)) {
          setSelectedDoctorsList([
            ...selectedDoctorsList,
            doctorData.ConnectorID,
          ]);
        }
        console.log('Checked true ::::::::  ', unCheckedItems);
        const tempSel = unCheckedItems.filter(
          (item) => item.ConnectorID !== doctorData.ConnectorID,
        );
        console.log('tempSelec :::::::: ', tempSel);
        setUnCheckedItems(tempSel);
      } else {
        setSelectedDoctorsList(
          [...selectedDoctorsList].filter(
            (docConnectorId) => docConnectorId !== doctorData.ConnectorID,
          ),
        );
        if (
          Object.prototype.hasOwnProperty.call(
            doctorsDataListObject,
            doctorData.ConnectorID,
          )
        ) {
          setUnCheckedItems([
            ...unCheckedItems,
            doctorsDataListObject[doctorData.ConnectorID],
          ]);
        }
      }
    }
  };

  return (
    <>
      {editAffiliatedRecords ? (
        <AddButton
          label={label}
          onClick={handleAddDoctors}
          className={'add-button-active'}
        />
      ) : (
        <AddButton label={label} className={'add-button-disable'} />
      )}
      <FilterModal
        showBackButton={false}
        isVisible={isModalOpen}
        onHide={() => {
          setIsModalOpen(false);
          setSearchString('');
          setCurrentPage(1);
          setDoctorsList([]);
          setSelectedDoctorsList([]);
          setHasMoreData(false);
          setDoctorsDataListObject({});
          setUnCheckedItems([]);
        }}
        applyFilterHandler={applyFilterHandler}
        showCancel={true}
        titleLabel="Doctors"
        showApply={true}
        showApplyLabel="Add Selected"
      >
        {
          <Container className="mt-3 mb-3">
            <Row>
              <Col sm={12}>
                <div>
                  <TextInput
                    parentClassName="mb-2"
                    label="Doctors"
                    append={
                      <InputGroup.Text>
                        <SearchSVG.SearchSVG className="primary-text-color" />
                      </InputGroup.Text>
                    }
                    inputProps={{
                      type: 'text',
                      placeholder: 'Search by Name, Specialty, Tax ID or NPI',
                      value: searchString,
                      onChange: onSearchHandler,
                      className: 'border-right-0',
                      autoFocus: false,
                      id: 'filter-broker-input',
                    }}
                  />
                </div>
              </Col>
            </Row>
            {doctorsList && doctorsList.length ? (
              <>
                <Row>
                  <Col sm={12} className="mt-4 mb-2">
                    <div className=" select-all-row d-flex">
                      <input
                        type="checkbox"
                        id="select-all-doctors"
                        name="select-all-doctors"
                        className="p-0 mt-auto mb-auto"
                        onChange={(e) => {
                          selectChangeHandler(e);
                        }}
                        checked={
                          doctorsList.filter((value) =>
                            selectedDoctorsList.includes(value),
                          ).length === doctorsList.length
                        }
                      />
                      <label
                        className="my-auto select-all-checkbox"
                        htmlFor="select-all-doctors"
                      >
                        Select All
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} className="mb-1">
                    <Lists
                      data={doctorsList}
                      dataObject={doctorsDataListObject}
                      selectChangeHandler={selectChangeHandler}
                      searchString={searchString}
                      selectedDoctorIds={selectedDoctorsList}
                      isLoading={isLoadingPage}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 ml-1">
                  {hasMoreData && (
                    <div
                      className="panel-card-link"
                      onClick={() => {
                        setCurrentPage((val) => val + 1);
                      }}
                      role="button"
                    >
                      Show More
                    </div>
                  )}
                </Row>
              </>
            ) : (
              <>
                {searchString?.length < 3 && !isLoadingPage && (
                  <Container className="mt-3 mb-3">
                    <SearchIndicationPage />
                  </Container>
                )}
                {!isLoadingPage &&
                  doctorsList &&
                  doctorsList.length === 0 &&
                  searchString?.length > 0 && (
                    <Container className="mt-3 mb-3">
                      <div>No Records Found</div>
                    </Container>
                  )}
                {isLoadingPage && <Skeleton count={20} height={30} />}
              </>
            )}
          </Container>
        }
      </FilterModal>
    </>
  );
};

export default DoctorPanel;
